













import { Component, Prop, Vue } from 'vue-property-decorator'

import { mdiChevronRight } from '@mdi/js'

import type { RawLocation } from 'vue-router'

export type BreadcrumbsItem = {
  text: string
  disabled: boolean
  to?: RawLocation
}

@Component
class Breadcrumbs extends Vue {
  @Prop({
    type: Array,
    required: true,
  })
  readonly items!: Array<BreadcrumbsItem>

  icons = {
    mdiChevronRight,
  }
}

export default Breadcrumbs
